import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import type { ContentTable } from 'pdfmake/interfaces';
import type { GetStandardFormFieldLabel } from 'src/hooks/forms/useFormCustomisation';

import { useLazyGetCausesByParentIssueId } from '@/hooks/queries';
import { createTable, tableHeaders } from '@/utils/pdf/table';

const useCausesExportTable = (
  issueId: string,
  getStandardFieldLabel: GetStandardFormFieldLabel
): [() => Promise<ContentTable>, boolean] => {
  const { getLabel: getSignificanceLabel } = useRating('significance');
  const [getCauses, getCausesResult] = useLazyGetCausesByParentIssueId();

  const createExportTable = async () => {
    const { data: causesData } = await getCauses({ parentIssueId: issueId });
    const causesTableData = (causesData?.cause ?? []).map((i) => [
      i.Title,
      getSignificanceLabel(i.Significance),
      i.Description ?? '',
    ]);

    return createTable({
      widths: '*',
      body: [
        tableHeaders([
          getStandardFieldLabel('cause', 'Title'),
          getStandardFieldLabel('cause', 'Significance'),
          getStandardFieldLabel('cause', 'Description'),
        ]),
        ...causesTableData,
      ],
    });
  };

  return [createExportTable, getCausesResult.loading];
};

export default useCausesExportTable;
